import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import ClassificacaoRequisito from "model/auditoria5s/ClassificacaoRequisito";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ClassificacaoRequisitoService from "service/auditoria5s/ClassificacaoRequisitoService";

const classificacaoRequisitoService = new ClassificacaoRequisitoService();

export default function ClassificacaoRequisitoCadastro() {

    const { setError, formState: { errors }, register, clearErrors } = useForm();

    const titulo = "Classificação de Requisito"

    const [classificacaoRequisito, setClassificacaoRequisito] = useState<ClassificacaoRequisito>(new ClassificacaoRequisito());

    function validar() {

        if (!classificacaoRequisito.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório" }, { shouldFocus: true })
            return false;
        }

        return true;
    }


    return (

        <BaseCadastro model={classificacaoRequisito} service={classificacaoRequisitoService} setModel={(value: ClassificacaoRequisito) => setClassificacaoRequisito(value)} validar={() => validar()} urlService="/classificacaoRequisito" pathCadastro="/classificacaoRequisito" tituloPagina={'Classificacao'}>
            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText required value={classificacaoRequisito.nome} style={{ width: '100%' }}
                        className={errors.nome ? "p-invalid" : ""}
                        {...register("nome", {
                            onChange: (e) => {
                                clearErrors("nome");
                                setClassificacaoRequisito({ ...classificacaoRequisito, nome: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>
            <div className="row">
                <Label className="col col-sm-12">Descrição</Label>
                <div className="col-sm-12">
                    <InputText required value={classificacaoRequisito.descricao} style={{ width: '100%' }}
                        onChange={(e) => setClassificacaoRequisito({ ...classificacaoRequisito, descricao: e.target.value })}
                    />
                </div>
            </div>
        </BaseCadastro>
    )
}
